<template>
  <div>
    <div id="video-asset-wrapper" class="px-3 py-4 container">
      <MuxAttendeeVideoPlayer
        id="mux-video-player"
        :event-attendee="eventAttendee"
        :embed-responsive-item="true"
        :video-asset="videoAsset"
        :theme="theme"
      />
      <AttendeeVideoAssetDetailsSectionVue :video-asset="videoAsset"/>
    </div>

  </div>
</template>

<script>
import MuxAttendeeVideoPlayer from '../video/MuxAttendeeVideoPlayer.vue';
import AttendeeVideoAssetDetailsSectionVue from './AttendeeVideoAssetDetailsSection.vue';
  export default {
    data() {
      return {
        theme: 'city'
      }
    },
    props: {
        event: {
            type: Object,
            required: true
        },
        videoAsset: {
            type: Object,
            required: true,
        },
        eventAttendee: {
            type: Object,
            required: true,
        },
    },
    components: { MuxAttendeeVideoPlayer, AttendeeVideoAssetDetailsSectionVue }
}
</script>

